import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en_US from './locales/en-us/translation.json';
import ko_KR from './locales/ko-kr/translation.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en_US: {
                translation: en_US,
            },
            ko_KR: {
                translation: ko_KR,
            },
        },
        lng: "ko_KR",
        fallbackLng: "ko_KR",
        ns: ['page'],
        interpolation: {
            escapeValue: false
        }
    });

export default i18n